import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreditReportVariable } from 'enums/LoanFormVariables';

interface CreditReportInterface {
  [CreditReportVariable.SocialSecurityNumber]: string;
}

export const initialState: CreditReportInterface = {
  [CreditReportVariable.SocialSecurityNumber]: '',
};

const creditReport = createSlice({
  name: 'creditReport',
  initialState,
  reducers: {
    setCreditReportData: (state: CreditReportInterface, { payload }: PayloadAction<CreditReportInterface>) => {
      state[CreditReportVariable.SocialSecurityNumber] = payload[CreditReportVariable.SocialSecurityNumber];
    },
  },
});

export const { setCreditReportData } = creditReport.actions;

export default creditReport.reducer;
